module.exports = __webpack_public_path__ + "img/bg_genesight_nucleotide_white.1d7e88c3.png";